import { render, staticRenderFns } from "./staffloads.vue?vue&type=template&id=48ccdc69&"
import script from "./staffloads.vue?vue&type=script&lang=js&"
export * from "./staffloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports